import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { audiosAssets } from "../../../assets/audio";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { useNavigate } from "react-router-dom";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivity: 100,
	dialogTwo: 2,
	dialogThree: 3,
	panelInstructionOne: 101,
	infoCoffe5: 4,
	infoCoffe4: 5,
	infoCoffe3: 6,
	infoCoffe2: 7,
	infoCoffe1: 8,
	dialogFour: 9,
	// parte2
	dialogFive: 10,
	dialogSix: 11,
	dialogSeven: 12,
	dialogEight: 13,
	dialogNine: 14,
	dialogTen: 15,
	dialogEleven: 16,
	panelInfo: 17,

	win: 200,
	hiddenUI: 50,
};

const stepRayCaster = {
	Contenedor_5: steps.infoCoffe5,
	Contenedor_4: steps.infoCoffe4,
	Contenedor_3: steps.infoCoffe3,
	Contenedor_2: steps.infoCoffe2,
	Contenedor_1: steps.infoCoffe1,
};

export const Team2SubtopicTwoActivityThree = () => {
	const dispatch = useDispatch()
	const navigator = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 3);
	const stepSelectRayCaster = useRef(0);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 3, 3d Scene 3');
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicThree.clickedRayCaster, (step) => {
		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		const isNextMove = stepSelectRayCaster.current === clickRayCaster;

		if (!isNextMove) {
			return;
		}

		if (clickRayCaster === steps.infoCoffe5) {
			setUiToShow(steps.infoCoffe5);
			selectIluminate(steps.infoCoffe4);
		}
		if (clickRayCaster === steps.infoCoffe4) {
			setUiToShow(steps.infoCoffe4);
			selectIluminate(steps.infoCoffe3);
		}
		if (clickRayCaster === steps.infoCoffe3) {
			setUiToShow(steps.infoCoffe3);
			selectIluminate(steps.infoCoffe2);
		}
		if (clickRayCaster === steps.infoCoffe2) {
			setUiToShow(steps.infoCoffe2);
			selectIluminate(steps.infoCoffe1);
		}
		if (clickRayCaster === steps.infoCoffe1) {
			setUiToShow(steps.dialogFour);
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a04T2)
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityOne.eliminateAnimation, step);
		}
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.finishClickAct3Part2, () => {
		setUiToShow(steps.win)
	});

	const selectIluminate = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			console.log("no se enctro");
			return;
		}
		const [key] = foundEntry;
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
	};

	const hiddenSelectObject = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			console.log("no se enctro");
			return;
		}
		const [key] = foundEntry;
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.hiddenUI && <></>}
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 3: Operación Maquinas de café Sabores" />
					<DialogBarNew
						dialog={
							"¿Sabes cuáles son las variedades de sabor en la capuchinera? Puedes identificarlas por las letras que se señalan en el contenedor."
						}
						percentage={"25%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityOne.visibleCoffeMake);
							setUiToShow(steps.panelActivity);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a02T2)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityOne.visibleCoffeMake);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.moveCoffeTable);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Puedes identificar las por las letras que se señalan en el contenedor y por los nombres que vienen en los botones para dispensar el café."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a03T2)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={`¡Ojo!, en tu tienda puedes tener de 1 a 3 Máquinas de Capuchino, al contar con más de 1, contarás con más sabores, por lo que deben ser revisadas y ejecutadas para contar en todo momento con la propuesta disponible.`}
						percentage={"75%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelInstructionOne)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelInstructionOne && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							hiddenSelectObject(steps.infoCoffe5);
						}}
						img={imgInstructionTeam2.team2_sub2_act_3_01}
					/>
				</>
			)}
			{uiToShow === steps.infoCoffe5 && (
				<>
					<NameContainer name="Regular (R)" />
				</>
			)}

			{uiToShow === steps.infoCoffe4 && (
				<>
					<NameContainer name="Vainilla (V)" />
				</>
			)}
			{uiToShow === steps.infoCoffe3 && (
				<>
					<NameContainer name="Moka (M)" />
				</>
			)}
			{uiToShow === steps.infoCoffe2 && (
				<>
					<NameContainer name="Canela (C)" />
				</>
			)}
			{uiToShow === steps.infoCoffe1 && (
				<>
					<NameContainer name="Chocolate (CH)" />
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<NameContainer name="Chocolate (CH)" />
					<DialogBarNew
						dialog={"¡Ahora ya conoces las variedades de sabor de uno de nuestros productos estrella!, debes tenerlos muy presentes."}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a05T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityThree.initAct3Part2)
							setUiToShow(steps.dialogSix)
						}}
					></DialogBarNew>
				</>
			)}

			{/* parte dos de actividad 3 */}

			{/* {uiToShow === steps.dialogFive && (
				<>
					<HeaderRedPresentation name="Actividad 3: Máquina de capuchino componentes" />
					<DialogBarNew
						dialog={"¡Ahora ya conoces las variedades de sabor de uno de nuestros productos estrella!, debes tenerlos muy presentes."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a05T2)
							// ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogSix)
						}}
					></DialogBarNew>
				</>
			)} */}
			{uiToShow === steps.dialogSix && (
				<>
					<HeaderRedPresentation name="Actividad 3: Máquina de capuchino componentes" />
					<DialogBarNew
						dialog={
							"Ahora conoceremos cómo es que se manejan las máquinas de café, ¡acompáñame!."
						}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a06T2)
							setUiToShow(steps.dialogSeven)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSeven && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"Para la máquina de capuchino es importante revisar que el contenedor se encuentre con suficiente polvo de café."
						}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a07T2)
							setUiToShow(steps.dialogEight)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<DialogBarNew
					dialog={"En caso de no tenerlo, deberás retirar el contenedor de polvo de café para verificar el nivel actual, eso lo logras agitándolo."}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a08T2)
						setUiToShow(steps.dialogNine)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogNine && (
				<DialogBarNew
					dialog={"Si el polvo se encuentra por debajo del nivel  mínimo de exhibición, rellénalo con su respectivo sabor."}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a09T2)
						setUiToShow(steps.dialogTen)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTen && (
				<DialogBarNew
					dialog={"Una vez realizado esto, coloca de nuevo el contenedor en la máquina. Asegúrate de que embone perfectamente, de ser necesario, gira la pieza trasera de mariposa."}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act3_a10T2)
						setUiToShow(steps.dialogEleven)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogEleven && (
				<DialogBarNew
					dialog={"Después, gira el codo servidor de cada contenedor hacia abajo apuntando hacia el embudo."}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.moveCoffeTable)
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityOne.visibleCoffeMake);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityTwo.animatePartCoffeMaker);
						setUiToShow(steps.panelInfo)
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.panelInfo && (
				<>
					<div
						onClick={() => {
						}}
						className="fixed z-40 top-3 right-3 rounded-2xl h-[104px] w-[252px] md:h-[136px] md:w-[359px] bg-white px-8 py-2 md:px-12 md:py-4"
					>
						<div className="h-full w-full flex flex-col gap-2 md:gap-4">
							<PointsInfo color="#FFC427" name="Codos exteriores" />
							<PointsInfo color="#E3211B" name="Extractor de vapor y embudo" />
							<PointsInfo color="#FFC427" name="Surtidores" />
						</div>
					</div>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda revisar los contenedores para que nuestros clientes disfruten de su bebida."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema2,
								})
							);
							navigator("/home2/tema2/subtema2/activityFour");
						}}
					/>
				</>
			)}

		</>
	);
};

const NameContainer = ({ name = "" }) => {
	return (
		<>
			<div className="fixed z-40 top-[30px] left-[310px] md:top-[30px] md:left-[50%] md:-translate-x-1/2 bg-[#F59E0B] w-[200px] h-[20px] md:w-[400px] md:h-[60px] rounded-lg flex justify-center items-center">
				<span className="font-semibold text-white text-[16px]">{name}</span>
			</div>
		</>
	);
};

const PointsInfo = ({ color = "#ccc", name = "" }) => {
	return (
		<div className="h-1/3 w-full flex gap-2 items-center">
			<div className="rounded-full h-5 w-5" style={{ backgroundColor: color }} />
			<span className="text-[10px] md:text-[16px]">{name}</span>
		</div>
	);
};

